import Events from './Events';

export default Events;
